import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page401Component } from './page-401/page-401.component';
import { Page404Component } from './page-404/page-404.component';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';

// common libraries


@NgModule({
  declarations: [
    Page401Component,
    Page404Component
  ],
  imports: [
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PhBhpUiModule
  ]
})
export class PagesModule { }
